"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

// Константы
var BIG_WIDTH = 1199;
var MEDIUM_WIDTH = 639;
var SMALL_WIDTH = 320; // var scrollableSelectors = '.catalog-layout__sidebar_container,.page-header__menu nav';

document.body.scrollEnabled = true; // var canTouchMove = true;
// var startedPos = 0;

var scrollTop = 0;
var fixedBody = false; // $(scrollableSelectors).on('touchmove', function (e) {
//     e.stopPropagation();
//     e.stopImmediatePropagation();
//     var directionTop = startedPos - e.originalEvent.touches[0].clientY <= 0;
//     if (
//         (directionTop && e.currentTarget.scrollTop === 0) ||
//         (!directionTop && e.currentTarget.scrollTop >= e.currentTarget.scrollHeight - e.currentTarget.offsetHeight)
//     ) {
//         e.preventDefault();
//     }
// });
// var touchStart = function (e) {
//     var $scrollableParent = $(e.target).closest(scrollableSelectors);
//     if ($scrollableParent.length > 0) {
//         var par = $scrollableParent.get(0);
//         var scrollLimit = par.scrollHeight - par.offsetHeight;
//         canTouchMove = scrollLimit > 0;
//         if (canTouchMove) {
//             startedPos = e.touches[0].clientY;
//         }
//         return;
//     }
//     canTouchMove = false;
// };

var scrollDisableTarget = document.body;

document.body.disableScroll = function () {
  scrollTop = scrollDisableTarget.scrollTop;
  scrollDisableTarget.classList.add('scroll-disabled');
  if (fixedBody) scrollDisableTarget.style.top = -scrollTop + 'px';
  document.body.scrollEnabled = false; // document.addEventListener('touchstart', touchStart);
};

document.body.enableScroll = function () {
  scrollDisableTarget.classList.remove('scroll-disabled');

  if (fixedBody) {
    scrollDisableTarget.style.top = '';
    scrollDisableTarget.scrollTop = scrollTop;
  }

  document.body.scrollEnabled = true; // canTouchMove = true;
  // document.removeEventListener('touchstart', touchStart);
}; // document.addEventListener('touchmove', function (e) {
//     try {
//         if (!canTouchMove) e.preventDefault();
//     } catch (err) {
//         console.log(err.message);
//     }
// }, { passive: false });
// Убери лишние 2 слеша чтобы подключить модуль
////=require components/insertRule.js
////=require components/double_tap.js

/**
 * Модальное окно
 * Показать: $(modal_selector).modal('show');
 * Скрыть: $(modal_selector).modal('hide');
 * Забиндить по нажатию на ссылку по href: $(link_selector).modal('bindHref');
 * Забиндить по нажатию на ссылку по data: $(link_selector).modal('bindData');
 */


(function ($) {
  var MODAL_POSITION_INNER = 'inner';
  var MODAL_POSITION_OUTER = 'outer';
  var modal_defaults = {
    closePos: MODAL_POSITION_INNER,
    // Позиция кнопки закрытия. Может быть внутри или снаружи самого окна
    scrollBackground: true,
    // Флаг прокрутки контента за модалкой
    initOnInclude: true // Активировать все модалки при подключении модуля (рекомендуется для нормального отображения слика).

  };
  var methods = {
    bindHref: function bindHref() {
      this.on('click', function (e) {
        $($(this).attr('href')).modal('show');
        e.preventDefault();
      });
    },
    bindData: function bindData() {
      this.on('click', function (e) {
        var $btn = $(this),
            $mod = $($btn.data('modal'));
        $mod.modal('show');

        try {
          var title = $btn.data('modal-title') || '',
              button = $btn.data('modal-button') || '';

          if (title.length > 0) {
            $mod.find('.modal-title').text(title);
          }

          if (button.length > 0) {
            $mod.find('.button-pill').text(button);
          }
        } catch (e) {
          console.log('Ошибка при попытке распарсить данный попапу объект ' + e.message);
        }

        e.preventDefault();
      });
    },
    init: function init(modal) {
      var $modalTemplate = $('<div class="modal modal-initialized"><div class="modal-container"><div class="modal-overlay"></div></div></div></div>');
      $modalTemplate.find('.modal-container').append(modal.detach());
      var $buttonClose = $('<button class="modal-close" type="button"></button>');
      if (modal_defaults.closePos === MODAL_POSITION_INNER) modal.prepend($buttonClose);else modal.parent().prepend($buttonClose);
      var id = modal.attr('id');
      modal.attr('id', '');
      $modalTemplate.attr('id', id);
      $('body').append($modalTemplate);
      modal = $modalTemplate.fadeIn(); // Если в модалке слик то его при инициализации нужно переинициализировать,
      // иначе он либо не отработает либо отработает криво.
      // var sld = modal.find('.slick-slider');
      //
      // if(sld.length){
      //     sld.slick('reinit');
      //      /*setTimeout(function(e){
      //      sld.slick('slickGoTo', 0)
      //      }, 10);*/
      // }
    },
    show: function show(modal) {
      // Ежели нам не дали в функцию модалку - пускай это будет текущий элемент
      if (modal == undefined) modal = this; // Проверим инициализацию модалки и если не инициализирована - создадим темплейт

      if (!modal.hasClass('modal-initialized')) {
        methods.init(modal);
      } // Делаем модалку видимой


      modal.addClass('visible'); // Ищем кнопку закрытия модалки и подложку и вешаем на них событие закрытия модалки

      modal.find('.modal-close, .modal-overlay, .modal-closeme').click(function (event) {
        modal.modal('hide'); //event.preventDefault();
      }); // Если высота окна меньше чем высота модалки то запрещаем скроллить html (модалка скроллится)

      if (!modal_defaults.scrollBackground || $(window).height() < modal.find('.modal-container')["0"].clientHeight) {
        document.body.disableScroll();
      }

      modal.trigger('modalOpenned');
      var sld = modal.find('.slick-slider');
      if (sld.length) sld.slick('reinit');
    },
    hide: function hide(modal) {
      if (modal == undefined) modal = this;
      if (!modal.hasClass('modal-initialized')) return;
      var ifr = modal.find('iframe');

      if (ifr.length) {
        ifr.parent().append(ifr.detach());
      }

      var vid = modal.find('video');

      if (vid.length) {
        vid.get(0).pause();
      } // Скрываем модалку


      modal.removeClass('visible'); // Выключаем слушатели событий нажатия с кнопок и подложки

      modal.find('.modal-close, .modal-overlay').off(); // Возвращаем возможность скроллинга html

      document.body.enableScroll();
      modal.trigger('modalClosed');
    },
    setOption: function setOption(opt) {
      modal_defaults = $.extend(JSON.parse(JSON.stringify(modal_defaults)), opt);
    }
  };

  $.fn.modal = function (method) {
    // логика вызова метода
    if (methods[method]) {
      return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
    } else {
      $.error('Метод с именем ' + method + ' не существует для jQuery.modal');
    }
  }; // При загрузке страницы заинициализируем все модалки


  if (modal_defaults.initOnInclude) {
    $('.modal-content').each(function (i, v) {
      var $me = $(v);

      if ($me.parents('.modal').length == 0) {
        $me.modal('init', $me);
      }
    });
  }
})(jQuery);
/**
 * Модуль аккордиона
 */


(function ($) {
  var accordion_defaults = {
    selfClose: true,
    // Позволять закрыть текущий элемент (нужно сочитать с multiple)
    multiple: true,
    // Если false то нельзя развернуть больше 1 аккордиона
    offFrom: 0,
    // Выключать аккордион начиная с этого размера экрана
    offset: 20,
    // Отступ от текущего выбранного элемента до верха экрана (при развороте)
    animSpeed: 300,
    // Скорость анимации открытия
    animEasingFunction: 'swing',
    // Функция анимации
    offScrollFrom: 720,
    // Выключить прокрутку, начиная с этого размера экрана (0 - не скроллить вообще)
    rollUpChilds: false,
    // Сворачивать ли детей при свертывании родителя
    doubleClickTo: 0 // До какого размера экрана отменяем первый клик на хедере (нужно для адаптивности) 0 - не отменяем

  };
  var accordion_methods = {
    'rollDown': function rollDown() {
      var $item = $(this);
      var opt = $item.data('accordion-options') || {};
      $item.children('.accordion-content').slideDown({
        duration: opt.animSpeed || accordion_defaults.animSpeed,
        easing: opt.animEasingFunction || accordion_defaults.animEasingFunction
      });
      $item.addClass('expanded');
      $item.trigger('expanded');
    },
    'rollUp': function rollUp() {
      var $item = $(this);
      var opt = $item.data('accordion-options') || {};
      $item.children('.accordion-content').slideUp({
        duration: opt.animSpeed || accordion_defaults.animSpeed,
        easing: opt.animEasingFunction || accordion_defaults.animEasingFunction
      });
      $item.removeClass('expanded');
      $item.trigger('collapsed');
    }
  };

  $.fn.accordion = function () {
    var options = accordion_defaults; // логика вызова метода

    if (arguments.length > 0) {
      if (typeof arguments[0] === "string") {
        if (accordion_methods[arguments[0]]) {
          return accordion_methods[arguments[0]].apply(this, arguments);
        } else {
          $.error('Метод с именем ' + arguments[0] + ' не существует для jQuery.accordion');
          return;
        }
      } else if (_typeof(arguments[0]) === "object") {
        options = $.extend(JSON.parse(JSON.stringify(accordion_defaults)), arguments[0]);
      }
    }

    var ww = $(window).width();
    this.addClass('accordion-root');
    this.data('accordion-options', options);

    if (options.doubleClickTo >= ww && $.event.special.doubletap != undefined) {
      this.children('.accordion-header').children('a').on('dblclick doubletap', function (e) {
        window.location = $(this).attr('href');
      }).on('click', function (e) {
        e.preventDefault();
      });
    }

    this.children('.accordion-header').on('click', function (e) {
      if (options.offFrom > 0 && ww > options.offFrom) {
        e.preventDefault();
        return;
      }

      var $me = $(this).parent();

      if (!options.multiple) {
        var $prev = $me.siblings('.expanded');

        if ($prev.get(0) != $me.get(0)) {
          $prev.children('.accordion-content').slideUp({
            duration: options.animSpeed,
            easing: options.animEasingFunction
          });
          $prev.removeClass('expanded');
        }
      }

      if (options.selfClose || !options.selfClose && !$me.hasClass('expanded')) {
        $me.children('.accordion-content').slideToggle({
          duration: options.animSpeed,
          easing: options.animEasingFunction
        });
        var has = $me.toggleClass('expanded').hasClass('expanded');

        if (has && options.offScrollFrom > ww) {
          $('body').animate({
            scrollTop: $me.offset().top - options.offset
          }, 700);
        }

        if (has) {
          $me.trigger('expanded');
        } else {
          $me.trigger('collapsed');
        }

        if (!has && options.rollUpChilds) {
          $me.find('.accordion-root.expanded').removeClass('expanded').children('.accordion-content').slideUp(1);
        }
      } //e.preventDefault();

    });
    return this;
  };
})(jQuery); ////=require components/tabs.js
////=require components/parallax.js
////=require components/select.js
////=require components/anim.js

/**
 * Модуль плавающего хедера с функцией "показать/скрыть" при прокрутке
 */


(function ($) {
  var defaults = {
    offset: 60,
    // Расстояние от верха страницы до хедера, с которого отключается фиксация.
    offFrom: 0 // Выключать фиксацию хедера начиная (исключая) с этого значения. 0 - не выключать (MobileFirst)

  };

  $.fn.floatHeader = function (opt) {
    var options = $.extend({}, defaults, opt),
        $hdr = this,
        offset = $hdr.height() + options.offset,
        $win = $(window),
        ww = $win.width(),
        lst = 0,
        floatHeaderInit = function floatHeaderInit() {
      var st = $win.scrollTop();
      if (st == lst) return;

      if (options.offFrom > 0 && ww <= options.offFrom || options.offFrom == 0) {
        var delta = lst - st;

        if (st > offset) {
          $hdr.addClass('fix');
        } else if (st == 0) {
          $hdr.removeClass('fix up down');
        }

        if ($hdr.hasClass('fix') && st > offset) {
          if (delta > 0) {
            $hdr.removeClass('down').addClass('up');

            if ($(this).scrollTop() < offset) {
              $hdr.removeClass('up').addClass('down');
            }
          } else if (delta < 0 && $hdr.hasClass('up')) {
            $hdr.removeClass('up').addClass('down');
          }
        }

        lst = st;
      }
    };

    floatHeaderInit();
    $(window).scroll(function (e) {
      if (!document.body.scrollEnabled) return;
      floatHeaderInit();
    });
    return this;
  };
})(jQuery); ////=require components/tooltip.js
////=require components/inputFile.js


var BreakpointManager = function BreakpointManager(breakpointList) {
  var $wnd = $(window),
      currBreakpoint,
      prevBreakpoint,
      setCurrBreakpoint = function setCurrBreakpoint() {
    var currInd = 0,
        ww = $wnd.width();

    for (var i = 0; i < breakpointList.length; i++) {
      if (ww > breakpointList[i]) {
        currInd = i;
      }
    }

    prevBreakpoint = currBreakpoint;
    currBreakpoint = Number(breakpointList[currInd]);

    if (prevBreakpoint != undefined && prevBreakpoint !== currBreakpoint) {
      $wnd.trigger('breakpointChanged');
    }
  };

  setCurrBreakpoint();
  $wnd.resize(function (e) {
    setCurrBreakpoint();
  });

  this.getCurrBreakpoint = function () {
    return currBreakpoint;
  };
};

var $window = $(window),
    ww = $window.width(),
    wh = window.innerHeight ? window.innerHeight : $(window).height(),
    $body = $('body'),
    $pw = $body.children('.page-wrap'),
    breakpointManager = new BreakpointManager([SMALL_WIDTH, MEDIUM_WIDTH, BIG_WIDTH]),
    util = {
  isTouch: function isTouch() {
    var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');

    var mq = function mq(query) {
      return window.matchMedia(query).matches;
    };

    if ('ontouchstart' in window || window.DocumentTouch && document instanceof DocumentTouch) {
      return true;
    } // include the 'heartz' as a way to have a non matching MQ to help terminate the join
    // https://git.io/vznFH


    var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
    return mq(query);
  },
  isIe: function isIe() {
    return navigator.userAgent.match(/Trident\/7.0/i);
  },
  isSafari: function isSafari() {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  },
  getNumberWithSpaces: function getNumberWithSpaces(num) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  },
  refreshCustomVH: function refreshCustomVH() {
    var vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', "".concat(vh, "px"));
  },
  getScrollbarWidth: function getScrollbarWidth() {
    var documentWidth = parseInt(document.documentElement.clientWidth),
        windowsWidth = parseInt(window.innerWidth);
    return windowsWidth - documentWidth;
  }
},
    app = {
  executeModules: function executeModules(modulesList) {
    for (var i = 0; i < modulesList.length; i++) {
      if (typeof modulesList[i] === 'function') {
        try {
          modulesList[i]();
        } catch (e) {
          if (util.isTouch()) {
            $body.append($('<span class="debug-message">Error occured in module ' + modulesList[i].name + ' with text: ' + e.message + '</span>'));
          }

          console.log('Error occured in module ' + modulesList[i].name + ' with text: ' + e.message);
        }
      }
    }
  },
  initSlick: function initSlick() {
    // Slick section
    if ($.fn.slick != undefined) {
      var sliders = {
        teamSlider: {
          infinite: false,
          arrows: true,
          dots: false,
          adaptiveHeight: false,
          variableWidth: true,
          mobileFirst: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          responsive: [{
            breakpoint: 715,
            settings: {
              slidesToShow: 2
            }
          }, {
            breakpoint: 1099,
            settings: {
              slidesToShow: 3
            }
          }, {
            breakpoint: 1499,
            settings: {
              slidesToShow: 4
            }
          }]
        },
        catalogItemDetailsNav: {
          infinite: false,
          arrows: false,
          dots: false,
          focusOnSelect: true,
          asNavFor: '#catalogItemDetailsContent',
          draggable: false,
          swipe: false
        },
        catalogItemDetailsContent: {
          infinite: false,
          arrows: true,
          dots: false,
          asNavFor: '#catalogItemDetailsNav',
          fade: true,
          adaptiveHeight: true
        },
        otherComplexesBlockSlider: {
          infinite: false,
          arrows: true,
          dots: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          mobileFirst: true,
          responsive: [{
            breakpoint: BIG_WIDTH,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          }]
        },
        oneApartmentSchemeSlider: {
          infinite: false,
          dots: true,
          arrows: true,
          onInit: function onInit(e, slick) {
            if (slick.$dots != null) {
              slick.$dots.find('button').each(function (i, v) {
                var icn = slick.$slides.eq(i).data('icon');
                $(v).css({
                  backgroundImage: 'url(' + icn + ')'
                });
              });
            }
          }
        },
        gallerySliderBlock: {
          infinite: false,
          dots: false,
          arrows: true,
          slidesToScroll: 1,
          slidesToShow: 1,
          mobileFirst: true,
          responsive: [{
            breakpoint: MEDIUM_WIDTH,
            settings: {
              slidesToShow: 2
            }
          }, {
            breakpoint: BIG_WIDTH,
            settings: {
              slidesToShow: 4
            }
          }]
        },
        aboutTeamSlider: {
          infinite: false,
          arrows: true,
          dots: false,
          mobileFirst: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          //variableWidth: true,
          responsive: [{
            breakpoint: MEDIUM_WIDTH,
            settings: {
              slidesToShow: 2
            }
          }]
        }
      };
      $('[data-slick]').each(function (i, v) {
        var $sld = $(v),
            sett = sliders[$sld.data('slick')];

        if (sett !== undefined) {
          $sld.on('init', sett.onInit);
          $sld.slick(sett);
        } else {
          return;
        } // Для добавления в слайдер счётчика слайдов.


        if ($sld.hasClass('slick-countered')) {
          $sld.on('init', function (e, slick) {
            $(this).append('<span class="slick-counter">' + (slick.currentSlide + 1 + ' / ' + slick.$slides.length) + '</span>');
          }).on('beforeChange', function (e, slick, curr, next) {
            $(this).find('.slick-counter').html(next + 1 + ' / ' + slick.$slides.length);
          });
        }

        if ($sld.hasClass('slick-startend')) {
          $sld.addClass('slick-start');
          $sld.on('beforeChange', function (e, slick, prev, next) {
            if (next == 0) {
              $sld.removeClass('slick-end').addClass('slick-start');
            } else if (next == slick.$slides.length - slick.options.slidesToShow) {
              $sld.removeClass('slick-start').addClass('slick-end');
            } else {
              $sld.removeClass('slick-start slick-end');
            }
          });
        }
      });
    }
  },
  initRellax: function initRellax() {
    if (Rellax) {
      var rellax = new Rellax('.rellax', {
        center: true
      });
    }
  },
  initOthers: function initOthers() {
    $('#menuBurger').click(function (e) {
      var has = $('#pageHeader').toggleClass('expanded').hasClass('expanded');

      if (has) {
        document.body.disableScroll();
      } else {
        document.body.enableScroll();
      }

      e.preventDefault();
    });
    $('.page-header').floatHeader({
      offset: 0
    });
    $('.hideall-after').click(function (e) {
      $(this).detach().off('click');
    }); // Кастомный vh

    util.refreshCustomVH();
    window.addEventListener('resize', function () {
      // We execute the same script as before
      util.refreshCustomVH();
    });
    document.documentElement.style.setProperty('--scrollbarWidth', util.getScrollbarWidth() + 'px');

    if (util.isTouch() && util.isSafari()) {
      fixedBody = true;
      document.documentElement.classList.add('fixable');
    }
  },
  removeBodyPreload: function removeBodyPreload() {
    $body.removeClass('preload');
  },
  addBodyPrefixes: function addBodyPrefixes() {
    var prefixes = [];
    if (util.isTouch()) prefixes.push('touch-device');
    if (util.isIe()) prefixes.push('is-ie');
    if (util.isSafari()) prefixes.push('is-safari');
    $body.addClass(prefixes.join(' '));
  },
  initListDropdowns: function initListDropdowns() {
    var documentClickListener = function documentClickListener(ee) {
      var $targ = $(ee.target);
      var trig = ee.data;
      var $dropdown = $targ.hasClass('.list-dropdown') ? $targ : $targ.parents('.list-dropdown').length > 0 ? $targ.parents('.list-dropdown') : null;

      if ($dropdown == null || $dropdown.get(0) !== $(trig).parents('.list-dropdown').get(0)) {
        trig.checked = false;
        $(document).off('click', documentClickListener);
      }
    };

    $(document).on('change', '.list-dropdown__trigger', function (e) {
      if (e.target.checked) {
        $(document).on('click', null, e.target, documentClickListener); // Расчёт положения дропдауна

        var $ld = $(e.target).parent();
        var lpos = $ld.offset().top - $window.scrollTop();
        var $sidebarContent = $ld.parents('.catalog-layout__sidebar_content');
        var fitsOnScreen = $sidebarContent.length > 0 && ww <= BIG_WIDTH ? $ld.position().top + $ld.height() + $ld.find('.list-dropdown__container').height() < $sidebarContent.height() : lpos + $ld.height() + $ld.find('.list-dropdown__container').height() + 10 < $window.height();

        if (!fitsOnScreen) {
          $ld.addClass('to-top');
        } else {
          $ld.removeClass('to-top');
        } // if (ww > BIG_WIDTH) {
        //     var srchFld = $ld.find('.list-dropdown__search input');
        //     if (srchFld.length > 0) {
        //         srchFld.focus();
        //     }
        // }

      } else {
        $(document).off('click', documentClickListener);
      }
    }).on('click', '.list-dropdown.self-close .list-dropdown__content button', function (e) {
      $(e.target).parents('.list-dropdown').children('.list-dropdown__trigger').get(0).checked = false;
    }).on('click', '.list-dropdown.self-close .list-dropdown__content button', function (e) {
      var $me = $(e.target);
      var $buttons = $me.parents('.list-dropdown__content').find('button');
      $buttons.removeClass('selected');
      $me.addClass('selected');
    });
  },
  initMaskedInput: function initMaskedInput() {
    if ($.fn.mask != undefined) $('input[type=tel]').mask('+7 (999) 999-99-99');
  },
  initPopups: function initPopups() {
    if ($.fn.modal != undefined) $('[data-modal]').modal('bindData');
  },
  initAccordions: function initAccordions() {
    if ($.fn.accordion != undefined) {
      $('.accordion').accordion();
      var $r = $('.main-scenario__container'),
          $accordions;

      if ($r.length > 0) {
        $accordions = $r.find('.accordion');
        $accordions.on('expanded', function (e) {
          if (breakpointManager.getCurrBreakpoint() >= MEDIUM_WIDTH) {
            $accordions.filter(':not(:eq(' + $(this).index() + '))').accordion('rollUp');
            $r.css({
              minHeight: $(this).find('.main-scenario__steps').height()
            });
          }
        });
        $window.on('breakpointChanged', function (e) {
          $accordions.accordion('rollUp');

          if (breakpointManager.getCurrBreakpoint() >= MEDIUM_WIDTH) {
            $accordions.first().accordion('rollDown');
          }
        });

        if (breakpointManager.getCurrBreakpoint() >= MEDIUM_WIDTH) {
          $accordions.first().accordion('rollDown');
        }
      }
    }
  },
  initCatalogLayout: function initCatalogLayout() {
    if ($pw.hasClass('catalog-page')) {
      var $layout = $('.catalog-layout'),
          $sidebar = $layout.children('.catalog-layout__sidebar'),
          sidebarHeight = $sidebar.outerHeight(),
          $showHide = $('#showHideFilters');

      var fixCatalogSidebar = function fixCatalogSidebar() {
        // Секция фиксации сайдбара
        var layoutOffset = $layout.offset().top,
            alwaysFixMode = sidebarHeight + layoutOffset < wh,
            prevSt = 0,
            checkSidebarScrollPos = function checkSidebarScrollPos() {
          var st = $window.scrollTop(),
              currTop = st + layoutOffset,
              currBottom = st + wh,
              delta = -(prevSt - st),
              layoutHeight = $layout.outerHeight(),
              maxTopPos = layoutHeight + layoutOffset - sidebarHeight;

          if (st > 0) {
            if (alwaysFixMode) {
              if (currTop < maxTopPos) {
                $sidebar.removeClass('bottom').addClass('fix');
              } else {
                $sidebar.removeClass('fix').addClass('bottom');
              }
            } else {
              if (currBottom >= layoutHeight + layoutOffset) {
                $sidebar.removeClass('fix').addClass('bottom').css({
                  top: ''
                });
              } else {
                var reposition = false;

                if (delta > 0) {
                  if (!$sidebar.hasClass('fix')) {
                    if ($sidebar.offset().top + sidebarHeight <= currBottom) {
                      $sidebar.addClass('fix').css({
                        top: -(sidebarHeight - wh)
                      });
                      reposition = true;
                    }
                  } else if (currBottom < $sidebar.offset().top + sidebarHeight) {
                    $sidebar.removeClass('fix').css({
                      top: st
                    });
                    reposition = true;
                  }
                } else {
                  if ($sidebar.hasClass('fix') && $sidebar.position().top < layoutOffset) {
                    $sidebar.removeClass('fix').css({
                      top: currBottom - sidebarHeight - layoutOffset
                    });
                    reposition = true;
                  } else if (currTop <= $sidebar.offset().top) {
                    $sidebar.addClass('fix').css({
                      top: layoutOffset
                    });
                    reposition = true;
                  }
                }

                if (reposition) $sidebar.removeClass('bottom');
              }
            }
          } else {
            $sidebar.removeClass('fix bottom').css({
              top: ''
            });
          }

          prevSt = st;
        };

        checkSidebarScrollPos();
        $window.scroll(checkSidebarScrollPos);
      };

      if (ww > BIG_WIDTH) {
        // $layout.css({
        //     minHeight: sidebarHeight
        // });
        if ($layout.height() < sidebarHeight) {
          //$sidebar.addClass('scrollable');
          // .css({
          //     maxHeight: $layout.outerHeight()
          // });
          $layout.css({
            minHeight: sidebarHeight
          });
        } //fixCatalogSidebar();

      }
      /*else{
                          $sidebar.css({
                              top: $showHide.offset().top + $showHide.height()
                          });
                            $layout.css({
                              minHeight: $sidebar.children().outerHeight()
                          });
                      }*/
      // else if(ww <= MEDIUM_WIDTH){
      //     var resizeSidebar = function(vh){
      //         $sidebar.css({
      //             height: vh
      //         });
      //     };
      //
      //     resizeSidebar(wh);
      //     $window.resize(function(e){
      //         resizeSidebar(window.innerHeight);
      //     });
      // }


      $showHide.click(function (e) {
        var isShow = $sidebar.toggleClass('show').hasClass('show');

        if (isShow && ww <= MEDIUM_WIDTH) {
          document.body.disableScroll();
        } else {
          document.body.enableScroll();
        }

        e.preventDefault();
      });
    }
  },
  initCatalogItemLayout: function initCatalogItemLayout() {
    var $catalogItemLayout = $('#catalogItemLayout');

    if ($catalogItemLayout.length && ww > MEDIUM_WIDTH) {
      var $nav = $catalogItemLayout.find('.catalog-item-layout__nav'),
          $navLinks = $nav.find('.nav a'),
          navOffset = $nav.offset().top,
          screenCenterOffset = 250,
          navTargetList = [],
          checkFixNav = function checkFixNav(st) {
        if (st > navOffset) {
          $nav.addClass('fix');
        } else {
          $nav.removeClass('fix');
        }
      },
          checkCurrentActiveNav = function checkCurrentActiveNav(st) {
        var currCenterPos = st + screenCenterOffset,
            found = false;

        for (var i = 0; i < navTargetList.length; i++) {
          var ot = navTargetList[i].offset().top;

          if (ot <= currCenterPos && currCenterPos < ot + navTargetList[i].outerHeight()) {
            found = true;

            if (!navTargetList[i].data('link').hasClass('active')) {
              $navLinks.removeClass('active');
              navTargetList[i].data('link').addClass('active');
            }

            break;
          }
        }

        if (!found) {
          $navLinks.removeClass('active');
        }
      },
          st = $window.scrollTop();

      $navLinks.each(function (i, v) {
        var $me = $(v),
            $targ = $($me.attr('href'));

        if ($targ && $targ.length) {
          navTargetList.push($targ.data('link', $me));
        }
      });
      checkFixNav(st);
      checkCurrentActiveNav(st);
      $window.scroll(function (e) {
        var st = $window.scrollTop();
        checkFixNav(st);
        checkCurrentActiveNav(st);
      });
    }
  },
  initFancybox: function initFancybox() {
    if ($.fn.fancybox != undefined) $('[data-fancybox]').fancybox({
      animationEffect: "fade",
      buttons: ["zoom", //"share",
      //"slideShow",
      //"fullScreen",
      //"download",
      //"thumbs",
      "close"]
    });
    $('[data-fancybox-open]').click(function (e) {
      var $me = $(this),
          targ = $me.data('fancybox-open');

      if (targ) {
        $('[data-fancybox="' + targ + '"]:eq(0)').click();
      }

      e.preventDefault();
    });
  },
  // initFieldsCustomFocus: function(){
  //     var $inputs = $('input, textarea');
  //     $inputs.focus(function (e) {
  //         $(this).addClass('focused');
  //     }).blur(function (e) {
  //         if ($(this).val().length == 0) {
  //             $(this).removeClass('focused');
  //         }
  //     });
  //
  //     $inputs.each(function (i, v) {
  //         var $me = $(v);
  //         if ($me.val().length > 0) {
  //             $me.addClass('focused');
  //         }
  //     });
  // },
  initSmoothScroll: function initSmoothScroll() {
    $('.smooth-scroll').click(function (e) {
      var $me = $(this),
          $targ = $($me.attr('href')),
          offset = 55;

      if (ww > MEDIUM_WIDTH) {
        var delta = $(window).scrollTop() - $targ.offset().top;
        offset = delta > 0 ? 200 : 100;
      }

      if ($targ.length) {
        $('html, body').animate({
          scrollTop: $targ.offset().top - offset
        }, 1000);
      }

      e.preventDefault();
    });
    var $scrollUpButton = $('#scrollUpButton');
    $scrollUpButton.click(function (e) {
      $('html, body').animate({
        scrollTop: 0
      }, 1000);
      e.preventDefault();
    });
    $(window).scroll(function (e) {
      var st = $window.scrollTop();

      if (st > wh) {
        $scrollUpButton.addClass('show');
      } else {
        $scrollUpButton.removeClass('show');
      }
    });
  }
};
$(function () {
  try {
    app.executeModules([app.initSlick, app.initRellax, app.initOthers, app.initMaskedInput, app.initSmoothScroll, app.initAccordions, app.initCatalogLayout, app.initCatalogItemLayout, app.initFancybox, app.initPopups, app.initListDropdowns, app.addBodyPrefixes]);
  } catch (e) {
    console.log('Произошла ошибка :( текст ошибки: ' + e.message);
  } finally {
    app.removeBodyPreload();
  }
});

function CommonForm($scope, $http, url, callback) {
  return function () {
    $scope.submitProcess = true;
    $http.post(url, $scope.model).then(function (resp) {
      $scope.resp = resp.data;
      $scope.submitProcess = false;

      if (callback) {
        callback();
      }
    });
  };
}